import React from 'react';
import AppLayout from '../Components/AppLayout';
import './App.css';
import '../Content/css/style.css';
import '../Content/css/colors/main.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
const App = () => (
  <>

    <ToastContainer />
    <AppLayout />
    
  </>
);

export default App;
